<template>
  <div id="app" v-cloak>
    <router-view/>
  </div>
</template>

<script>
export default {
  mounted(){
    let nowtime = Date.parse(new Date());
    // 存在刷新时间
    if(localStorage.getItem('updtime')){
      let updtime = localStorage.getItem('updtime');
      if(nowtime > Number(updtime) + 2 * 60 * 60 * 1000){
        localStorage.setItem('updtime',String(nowtime));
        setTimeout(()=>{
          location.reload();
        },1500)
      }
    }
    // 不存在
    else{
      localStorage.setItem('updtime',String(nowtime));
      setTimeout(()=>{
        location.reload();
      },1500)
    }
    
  },
}
</script>

<style lang="scss" scoped>
#app{
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue